module.exports = "/static/assets/c6285665b5164fa3387b494bf5fa4fef.png";